@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../../respond-to.scss';

.ciHeader {
  &-logo {
    border-bottom: 1px solid $color-gray-accent;
  }

  &-logo-wrapper {
    padding: $spacing-8 $spacing-8;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }

  &-logo-image {
    height: 40px;
  }

  &-CustomerSupport {
    display: flex;
    gap: 16px;

    &-divider {
      @media only screen and (max-width: 699px) {
        display: none;
      }
      border: 0.5px solid $color-gray-accent;
      margin: 3px 0;
    }
  }
}
